import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
    static values = {
        url: String,
    };

    declare readonly urlValue: string;

    connect(): void {
        const url = this.urlValue.trim();
        if (!url) {
            return;
        }

        const targetUrl = new URL(url, window.location.origin);
        const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        const targetPath = `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;

        if (currentPath === targetPath) {
            return;
        }

        window.location.assign(targetPath);
    }
}
